import { useEffect, useState } from 'react';
import { lazyHolderSingletonGetter, SubjectHolder } from '@maxtropy/components/es/lib/SubjectHolder';
import { AreaItem, fetchAreaJson } from '../api/cc-location';
import { useMgmtPermissions } from '@/components/Layout/hooks';

export function useHasPermission(key: string) {
  const [status, setStatus] = useState<boolean>(false);
  const corpUserFunctionPermission = useMgmtPermissions();
  useEffect(() => {
    setStatus((corpUserFunctionPermission ?? []).findIndex(i => i === key) !== -1);
  }, [corpUserFunctionPermission, key]);
  return status;
}

export function getParents(nodes: AreaItem[], key: string): AreaItem[] {
  const res = [];
  for (let node of nodes ?? []) {
    if (node.adcode === key) {
      res.unshift(node);
      break;
    } else {
      const children = getParents(node.districts ?? [], key);
      if (children && children.length) {
        res.unshift(node, ...children);
        break;
      }
    }
  }
  return res;
}

export function areaCodeToName(nodes: AreaItem[], key: string) {
  const res = getParents(nodes, key);
  return res.map(i => i.name).join('/');
}

export function formatDistrictData(data?: AreaItem[], filterKey?: string): AreaItem[] {
  if (!data) return [];
  return data
    .filter(item => item.adcode !== filterKey)
    .map(item => ({
      ...item,
      districts: item.districts ? formatDistrictData(item.districts, item.adcode) : undefined,
    }));
}

export const getAreaJson = /*#__PURE__*/ lazyHolderSingletonGetter(
  () => new SubjectHolder(() => fetchAreaJson().then(res => formatDistrictData(res?.districts)))
);

export function useAreaJson() {
  const currentInstance = getAreaJson();
  const [state, setState] = useState(currentInstance.current());

  useEffect(() => {
    const subcription = currentInstance.subscribe(setState);
    return () => {
      subcription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return state;
}
